import { InfoPage } from "@shapr3d/frontend-lib";

interface TeamInvitationErrorProps {
  errorType: "Invalid" | "NotAvailable" | "AlreadyAccepted";
}

const errorMessages = {
  Invalid: {
    ErrorTitle: "Invalid invitation.",
    ErrorMessage: "The invitation link is invalid.",
  },
  NotAvailable: {
    ErrorTitle: "Invitation is no longer available.",
    ErrorMessage: "Request a new invitation from your team owner to join your team.",
  },
  AlreadyAccepted: {
    ErrorTitle: "Invitation already accepted.",
    ErrorMessage: "Please log in to your account to start working with your team.",
  },
};

function TeamInvitationError(props: TeamInvitationErrorProps) {
  return (
    <InfoPage
      variant="information"
      title={errorMessages[props.errorType].ErrorTitle}
      description={errorMessages[props.errorType].ErrorMessage}
    />
  );
}

export default TeamInvitationError;
